import React from 'react';
import { navigate } from '@reach/router';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

import getStateColour from '../../../app/colours';

const getRfqStatus = status => {
    if (status === 'active') return 'quote in progress';
    if (status === 'completed') return 'quote provided';

    return status;
}

const WorkItem = ({ value, showWorkLinks = false }) => {
    const { booking, quote, rfq, timesheet, reference = '?' } = value;
    const bookingStatus = !booking?.completed ? 'live' : 'completed';
    const { items = [] } = timesheet || booking || quote || {};

    const description =
        items
            .filter(({ category, description, quantity }) => category === 'services' && description !== 'Travel Time' && Boolean(quantity))
            .map(({ description, date = '' }) => `${description} ${date}`).join(', ').trim();

    const goto = path => {
        if (showWorkLinks) {
            navigate(path);
        }
    }

    return (
        <Grid container spacing={1}>
            <Grid item>
                <Typography variant="body2">
                    {
                        description || rfq.message || reference
                    }
                </Typography>
            </Grid>
            <Grid item>
                {
                    !quote &&
                    <Chip
                        label={getRfqStatus(rfq.status)}
                        style={{
                            marginRight: '0.25rem', color: 'white',
                            backgroundColor: getStateColour(rfq.status)
                        }}
                        size="small"
                        onClick={() => goto(`/casework/referral/${rfq.id}`)}
                        clickable={showWorkLinks}
                    />
                }
                {
                    quote && !booking &&
                    <Chip
                        label={`quote ${quote?.status || 'draft'}`}
                        size="small"
                        style={{
                            marginRight: '0.25rem',
                            backgroundColor: getStateColour(quote.status), color: 'white'
                        }}
                        onClick={() => goto(`/casework/quote/${quote.id}`)}
                        clickable={showWorkLinks}
                    />
                }
                {
                    booking &&
                    <Chip
                        label={`booking ${bookingStatus}`}
                        size="small"
                        style={{
                            marginRight: '0.25rem',
                            backgroundColor: getStateColour(bookingStatus), color: 'white'
                        }}
                        onClick={() => goto(`/casework/timesheets/${booking.id}`)}
                        clickable={showWorkLinks}
                    />
                }
            </Grid>

        </Grid>
    );

}

export default WorkItem;